import MarkdownPage from "@/lib/components/MarkdownPage";

const markdownData = `
# Retningslinjer for bruk

Eventlista er helt norsk og forholder seg til norske lover og regler. Når du bruker Eventlista forplikter du deg til å følge norsk lov. Utover dette ønsker vi at vår plattform skal være et fritt sted hvor man stort sett kan skrive det man vil.

Eventlista har ikke et redaktøransvar. Du publiserer tekst og bilder og deler informasjon på eget ansvar.  Det betyr at du kan bli straffeforfulgt dersom lovbrudd blir oppdaget. Eventlista bedriver imidlertid ingen automatisk sensur eller kontroll av innhold du publiserer.

### Følgende er forbudt på Eventlista:

* Planlegging av vold, drap eller terror.
* Sjikane, mobbing, uthenging og publisering av persondata som ikke er din egen.
* Hacking, denial of service-angrep, og andre forsøk på hindre nettstedets operasjon.
* Uvedkommen bruk av noen andre sin Eventlista-konto.
* Forsøk på å oppdage linken til private og hemmelige eventer.
* Øvrig brudd på, eller oppfordring til brudd på norsk lov.

Brudd på regler vil kunne føre til utestengelse og/eller straffeforfølgelse.

*Sist oppdatert: 26. juli 2024*
`

export default function Index() {
    return (
        <MarkdownPage markdown={markdownData}/>
    )
}